import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { useUMAStats } from './UMAStatsContext';

// Import your slideshow images here
const splashImages = [
    require('../assets/welcome1.jpg'),
    require('../assets/welcome2.jpg'),
    require('../assets/welcome3.jpg'),
    require('../assets/welcome4.jpg'),
    require('../assets/welcome5.jpg'),
    require('../assets/welcome6.jpg'),
    require('../assets/welcome7.jpg'),
    require('../assets/welcome8.jpg'),
    require('../assets/welcome9.jpg'),
    require('../assets/welcome10.jpg'),
    // Add more image paths as needed
];

const Welcome = ({ token, onContinue }) => {
    const navigate = useNavigate();
    const [splashIndex, setSplashIndex] = useState(0);
    const [tokenValid, setTokenValid] = useState(false);
    const { fetchStats } = useUMAStats();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [redirected, setRedirected] = useState(false);

    // Validate token on mount
    useEffect(() => {
        if (token) {
            api.get('/users/me', { headers: { Authorization: `Bearer ${token}` } })
                .then(() => setTokenValid(true))
                .catch(() => {
                    localStorage.removeItem('uma_token');
                    setTokenValid(false);
                });
        } else {
            setTokenValid(false);
        }
    }, [token]);

    // Slideshow interval
    useEffect(() => {
        const interval = setInterval(() => {
            setSplashIndex(idx => (idx + 1) % splashImages.length);
        }, 6000);
        return () => clearInterval(interval);
    }, []);

    const handleInitiate = async () => {
        setLoading(true);
        setError('');
        if (tokenValid) {
            try {
                await fetchStats();
                setRedirected(true);
                if (onContinue) onContinue();
                navigate('/dashboard');
            } catch (e) {
                setError('Failed to fetch UMA stats.');
                setRedirected(true);
                if (onContinue) onContinue();
                navigate('/dashboard');
            }
        } else {
            setRedirected(true);
            if (onContinue) onContinue();
            navigate('/register');
        }
        setLoading(false);
    };

    if (redirected) return null;

    return (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-black z-50">
            <div className="relative w-full h-full">
                <img
                    src={splashImages[splashIndex]}
                    alt="Splash"
                    className="w-full h-full object-cover transition-opacity duration-700"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40" />
                {/* Move button to top left */}
                <div className="absolute top-8 left-8 flex justify-start gap-4">
                    <button
                        className="px-7 py-3 bg-white text-black rounded-full shadow-md text-lg font-semibold font-sans tracking-wide transition hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        onClick={handleInitiate}
                        disabled={loading}
                    >
                        {loading ? 'Loading...' : 'Initiate'}
                    </button>
                </div>
                {error && (
                    <div className="absolute bottom-36 left-0 right-0 text-center text-red-400 font-bold">
                        {error}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Welcome;